module.exports = __webpack_public_path__ + "static/Xenios40-56d7ce72e4f305017cf7e450cc3ca016.mp4";